import 'normalize.css';
import '../css/index.css';
import "@babel/polyfill";
import "core-js/es6";
import "regenerator-runtime/runtime";
import 'intersection-observer';
import "./modules/gtm";
import "./modules/ua";
import "./modules/parallax";
import "./modules/caroucel";
import "./modules/shareLinks";
import "./modules/copyLink";
import "./modules/lazyLoad";
import "./modules/innerNav";
import "./modules/stories";
import "./modules/splash";

// JSオン時
document.body.classList.remove('no-js');
